var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1403 20.2999V4.51172H30.1294V9.00764H21.1376V25.4927C21.1373 26.8122 20.7016 28.0948 19.8981 29.1415C19.0946 30.1882 17.9682 30.9406 16.6935 31.2819C15.4189 31.6232 14.0672 31.5344 12.8482 31.0292C11.6292 30.5241 10.6109 29.6309 9.95123 28.488C9.29158 27.3452 9.02745 26.0166 9.1998 24.7084C9.37214 23.4001 9.97133 22.1853 10.9044 21.2523C11.8376 20.3193 13.0525 19.7202 14.3607 19.548C15.669 19.3758 16.9975 19.6401 18.1403 20.2999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic2);
export default __webpack_public_path__ + "static/media/music2.fe90965e9ca006dc9e7a765f94f3abde.svg";
export { ForwardRef as ReactComponent };